var map = {
	"./app.js": "WSTi",
	"./dept.js": "F3Xy",
	"./dict.js": "qitd",
	"./goods.js": "omCk",
	"./router-permission.js": "qNx+",
	"./storage.js": "F6wv",
	"./tip.js": "dFGy",
	"./user.js": "bREw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "w+hY";


//////////////////
// WEBPACK FOOTER
// ./src/store/modules \.js$
// module id = w+hY
// module chunks = 1